import clsx from 'clsx';
import styles from './style';

export interface ButtonProps {
  className?: string;
  style?: any;
  bordered?: boolean;
  justify?: any;
  textColor?: any;
  borderColor?: any;
  buttonColor?: any;
  text?: string;
  renderChildren?: () => JSX.Element;
  onClick?: any;
  textStyle?: any;
  icon?: any;
  textClassName?: any;
  description?: string;
}

const Button = (props: ButtonProps) => {
  let className = props.className
    ? `button hover:border-black cursor-pointer rounded-sm ${props.className}`
    : clsx(
        'button hover:border-black cursor-pointer py-3 mx-auto flex justify-center items-center',
      );

  let iconStyles = {};

  switch (props.icon?.position) {
    case 'left':
      iconStyles = styles.leftIcon;
      break;
    case 'right':
      iconStyles = styles.rightIcon;
      break;
    case 'centerLeft':
      iconStyles = {};
      break;
    case 'centerRight':
      iconStyles = {};
      break;
  }

  const renderIcons = () => {
    return <div style={iconStyles}>{props.icon?.icon}</div>;
  };

  const style = props.style ? props.style : {};
  const textColor = props.textColor
    ? { color: props.textColor }
    : { color: 'black' };
  const textStyle = props.textStyle ? props.textStyle : null;
  const borderColor = props.borderColor
    ? { borderColor: props.borderColor }
    : null;

  const buttonColor = props.buttonColor
    ? { backgroundColor: props.buttonColor }
    : null;

  return (
    <div
      className={className}
      style={{ ...style, ...borderColor, ...buttonColor }}
      onClick={(e) => {
        if (props.onClick != null) {
          props.onClick(e);
          e.stopPropagation();
        }
      }}
      title={props.description}
    >
      {props.icon?.position === 'left' ? renderIcons() : null}
      {props.icon?.position === 'centerLeft' ? renderIcons() : null}
      {props.text ? (
        <span
          className={`${
            props.textClassName
              ? props.textClassName
              : 'text text-sm tracking-tighter text-[#121212]'
          } text-center break-keep`}
          style={{
            ...{
              wordBreak: 'keep-all',
            },
            ...textColor,
            ...textStyle,
          }}
          dangerouslySetInnerHTML={{ __html: props.text }}
        ></span>
      ) : null}
      {props.renderChildren ? props.renderChildren() : null}
      {props.icon?.position === 'centerRight' ? renderIcons() : null}
      {props.icon?.position === 'right' ? renderIcons() : null}
    </div>
  );
};

export default Button;
